import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const GetPoojaAtTempleDetailsBySlug = async (slug) => {
    const url = `${BaseUrl}/GetPoojaAtTempleDetailsBySlug?Slug=${slug}`;
    const res = await getApiWithAuthorization(url);

    return res;
};